// 静态大屏
<template>
  <div style="position: relative">
    <el-form
      ref="formSysPost"
      :model="formSysPost"
      label-width="100px"
      :size="defaultFormItemSize"
      label-position="right"
      @submit.native.prevent
    >
      <filter-box :item-width="350">
        <!-- <el-button
          slot="operator"
          type="primary"
          size="small"
          @click="addItem()"
        >
          新建
        </el-button> -->
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table
          ref="sysPost"
          :data="tableData"
          :size="defaultFormItemSize"
          header-cell-class-name="table-header-gray"
        >
          <el-table-column
            label="序号"
            header-align="center"
            align="center"
            type="index"
            width="55px"
            :index="formSysPost.sysPost.impl.getTableIndex"
          />
          <el-table-column label="可视化大屏名称" prop="name">
          </el-table-column>
          <el-table-column label="地址" prop="link">
            <template slot-scope="scope">
              <a
                :href="scope.row.link"
                target="_blank"
                rel="noopener noreferrer"
                >{{ scope.row.link }}</a
              >
              <!-- {{ typeObj[scope.row.modelType] }} -->
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px">
          <el-pagination
            background
            :total="pagination.total"
            :current-page="pagination.current"
            :page-size="pagination.size"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @size-change="handleSizeChange"
            @current-change="currentChange"
          >
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import rules from "@/utils/validate.js";
import {
  DropdownWidget,
  TableWidget,
  UploadWidget,
  ChartWidget,
} from "@/utils/widget.js";

export default {
  name: "LabelModel",
  props: {},
  components: {},
  // mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data() {
    return {
      formSysPost: {
        formFilter: {
          postName: undefined,
        },
        formFilterCopy: {
          postName: undefined,
        },
        sysPost: {
          impl: new TableWidget(
            this.loadSysPostWidgetData,
            this.loadSysPostVerify,
            true,
            false,
            "level",
            1
          ),
        },
        isInit: false,
      },
      typeObj: {
        1: "原材料",
        2: "模具",
        3: "成品",
      },
      modelTypeArr: [
        { label: "原材料", value: 1 },
        { label: "模具", value: 2 },
        { label: "成品", value: 3 },
      ],

      tableData: [
        //  xx
        // {
        //   name: "设备能耗看板",
        //   link: "http://web.p.zhan2345.com/web_xx/#/XXTwo",
        // },
        // {
        //   name: "生产看板",
        //   link: "http://web.p.zhan2345.com/web_xx/#/XXThree",
        // },
        // {
        //   name: "数据可视化大屏",
        //   link: "http://web.p.zhan2345.com/web_xx/#/XXFour",
        // },
        // zq
        // {
        //   name: "设备能耗看板",
        //   link: "http://web.p.zhan2345.com/web_xx/#/ZQTwo",
        // },
        // {
        //   name: "生产看板",
        //   link: "http://web.p.zhan2345.com/web_xx/#/ZQThree",
        // },
        // {
        //   name: "数据可视化大屏",
        //   link: "http://web.p.zhan2345.com/web_xx/#/ZQFour",
        // },
        // BY
        // {
        //   name: "设备能耗看板",
        //   link: "http://web.p.zhan2345.com/web_xx/#/BYTwo",
        // },
        // {
        //   name: "生产看板",
        //   link: "http://web.p.zhan2345.com/web_xx/#/BYThree",
        // },
        // {
        //   name: "数据可视化大屏",
        //   link: "http://web.p.zhan2345.com/web_xx/#/BYFour",
        // },
        // // HT
        // {
        //   name: "设备能耗看板",
        //   link: "http://web.p.zhan2345.com/web_xx/#/HTTwo",
        // },
        // {
        //   name: "生产看板",
        //   link: "http://web.p.zhan2345.com/web_xx/#/HTThree",
        // },
        // {
        //   name: "数据可视化大屏",
        //   link: "http://web.p.zhan2345.com/web_xx/#/HTFour",
        // },
        // RRF
        // {
        //   name: "设备能耗看板",
        //   link: "http://web.p.zhan2345.com/web_xx/#/RRFTwo",
        // },
        // {
        //   name: "生产看板",
        //   link: "http://web.p.zhan2345.com/web_xx/#/RRFThree",
        // },
        // {
        //   name: "数据可视化大屏",
        //   link: "http://web.p.zhan2345.com/web_xx/#/RRFFour",
        // },
      ],
      pagination: {
        size: 10,
        total: 0,
        page: 1,
        // current: 1
      },
      dialogVisible: false,
      title: 1, // 1、新增 2、编辑 3、详情
      row: {},
    };
  },
  methods: {
    async getTableData() {
      let { data } = await this.$api.getPrintModelList({
        pageParam: {
          pageNum: this.pagination.page,
          pageSize: this.pagination.size,
        },
      });
      this.tableData = data.dataList;
      this.pagination.total = data.totalCount;
    },
    // 重置
    reset() {
      this.tableParams = {};
      this.getTableData();
    },
    addItem() {
      this.row = {};
      this.title = 1;
      this.dialogVisible = true;
    },
    editItem(row) {
      this.row = row;
      this.title = 2;
      this.dialogVisible = true;
    },
    diaClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.title = null;
      }, 100);
    },
    // 新增
    async onAdd(params) {
      await this.$api.AddPrintModel(params);
      this.$message({
        message: "新增成功",
        type: "success",
      });
      this.dialogVisible = false;
      this.getTableData();
    },

    // 更新
    async onUpdate(params) {
      await this.$api.UpdatePrintModel(params);
      this.$message({
        message: "更新成功",
        type: "success",
      });
      this.dialogVisible = false;
      this.getTableData();
    },

    // 删除
    async onDel(row) {
      await this.$api.DelPrintModel({ id: row.id });
      this.$message({
        message: "删除成功",
        type: "success",
      });
      this.getTableData();
    },

    deleteItem(row) {
      this.$alert("是否删除当前数据？", "提示", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            this.onDel(row);
          }
        },
      });
    },

    // 切换page
    currentChange(val) {
      // console.log("val", val);
      this.changePagination({
        page: val,
        size: this.pagination.size,
      });
    },
    // 切换size
    handleSizeChange(val) {
      // console.log("val", val);
      this.changePagination({
        page: 1,
        size: val,
      });
    },
    changePagination(val) {
      this.pagination = {
        ...this.pagination,
        ...val,
      };
      this.getTableData();
    },
  },
  mounted() {
    // this.getTableData();
    // switch (this.$name) {
    //   case "xx":
    //     this.tableData = [
    //       {
    //         name: "设备能耗看板",
    //         link: "http://web.p.zhan2345.com/web_xx/#/XXTwo",
    //       },
    //       {
    //         name: "生产看板",
    //         link: "http://web.p.zhan2345.com/web_xx/#/XXThree",
    //       },
    //       {
    //         name: "数据可视化大屏",
    //         link: "http://web.p.zhan2345.com/web_xx/#/XXFour",
    //       },
    //     ];
    //     break;
    //   default:
    //     break;
    // }
    let obj = {
      syzg: 6012,
      cy: 6011,
      wt: 6010,
      cn: 6009,
      bl: 6008,
      xx: 6007,
      zq: 6006,
      by: 6005,
      ht: 6004,
      rrf: 6003,
      ps: 6002,
      abl: 6001,
    };
    if (this.$name == "zq") {
      this.tableData = [
        {
          name: "设备看板",
          link: "http://192.168.137.253:8090/#/zqfive",
        },
        {
          name: "生产车间管理 小线",
          link: "http://192.168.137.253:8090/#/zqsix",
        },
        {
          name: "生产车间管理 中线",
          link: "http://192.168.137.253:8090/#/ZQseven",
        },
        {
          name: "生产车间管理 大线",
          link: "http://192.168.137.253:8090/#/ZQeight",
        },
        {
          name: "生产车间管理总看板",
          link: "http://192.168.137.253:8090/#/ZQnine",
        },
      ];
    } else {
      this.tableData = [
        {
          name: "设备能耗看板",
          link:
            "http://36.26.71.100:" +
            obj[this.$name] +
            "/#/" +
            this.$name +
            "Two",
        },
        {
          name: "生产看板",
          link:
            "http://36.26.71.100:" +
            obj[this.$name] +
            "/#/" +
            this.$name +
            "Three",
        },
        {
          name: "数据可视化大屏",
          link:
            "http://36.26.71.100:" +
            obj[this.$name] +
            "/#/" +
            this.$name +
            "Four",
        },
      ];
    }
  },
  activated() {
    // this.getTableData();
  },
  watch: {},
};
</script>
